<template>
  <el-pagination
    layout="prev, pager, next"
    :hide-on-single-page="pagination.count / 10 <= 1"
    background
    :total="pagination.count"
    @current-change="handleCurrentChange"
    :current-page.sync="pagination.current"
  ></el-pagination>
</template>

<script>
import { axiosFactory, errorHandler } from '@/configs/axios'
export default {
  props: {
    pagination: {
      type: Object,
      default: null,
      required: false,
    },
    parameter: {
      type: String,
      default: '?',
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit('loading', true)
      this.$router.push({ query: { ...this.$route.query, p: val } })
    },

    pageChanged(val) {
      // Get current query parameters from the route
      const currentQuery = { ...this.$route.query }
      delete currentQuery.p // Remove the page parameter as we're setting it explicitly

      // Build query string from current route parameters
      const queryParams = Object.keys(currentQuery)
        .filter(
          (key) =>
            currentQuery[key] !== '' &&
            currentQuery[key] !== null &&
            currentQuery[key] !== undefined
        )
        .map((key) => `${key}=${encodeURIComponent(currentQuery[key])}`)
        .join('&')

      axiosFactory()
        .auth.get(
          `${this.pagination.request}${
            this.parameter == '?' ? '?' : '&'
          }p=${val}${queryParams ? `&${queryParams}` : ''}`
        )
        .then((res) => {
          this.$emit('loading', false)
          this.$emit('tableData', res.data)
        })
        .catch((error) => {
          this.$emit('loading', false)
          errorHandler(error)
        })
    },
  },

  watch: {
    $route(to, from) {
      if (to.query.p !== from.query.p) {
        this.pageChanged(to.query.p || 1)
      }
    },
  },
}
</script>
